import { SET_STOP_STREAM_CONFIRMATION } from 'actions/Types';

export default (state = null, action) => {
  if (action.type === SET_STOP_STREAM_CONFIRMATION) {
    return action.payload;
  }

  return state;
};
